import { useCallback, useEffect, useLayoutEffect, useState } from 'preact/hooks';
import { changes } from '../../subs';
import { Change } from '../../types';
import { useAdWindow } from './useAdWindow';
import { useMaxSlotSize } from './useMaxSlotSize';

export function useAdSize() {
  const win = useAdWindow();
  const [size, setSize] = useState({ width: win.innerWidth, height: win.innerHeight });
  const [hasVPAIDChanges, setHasVPAIDChanges] = useState(false);
  const maxSlotSize = useMaxSlotSize();

  useEffect(() => {
    setSize(({ width, height }) => {
      return {
        width: maxSlotSize.width ? Math.min(win.innerWidth, maxSlotSize.width) : width,
        height,
      };
    });
  }, [maxSlotSize.width, win.innerWidth]);

  function onVPAIDChanges({ event, partial }: Change) {
    if (event === 'AdSizeChange') {
      setHasVPAIDChanges(true);
      setSize(partial as { width: number; height: number });
    }
  }

  useLayoutEffect(() => {
    changes && changes.subscribe(onVPAIDChanges);
    return () => changes && changes.unsubscribe(onVPAIDChanges);
  }, []);

  const onWindowResize = useCallback(() => {
    setSize(({ width, height }) => ({
      width: maxSlotSize.width ? Math.min(win.innerWidth, maxSlotSize.width) : width,
      height: maxSlotSize.height ? Math.min(win.innerHeight, maxSlotSize.height) : height,
    }));
  }, [win, maxSlotSize]);
  useLayoutEffect(() => {
    if (!hasVPAIDChanges) {
      win.addEventListener('resize', onWindowResize);
      return () => win.removeEventListener('resize', onWindowResize);
    }
  }, [hasVPAIDChanges, onWindowResize]);
  return size;
}
